// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__3EaA9","label":"Input_label__1wAlI"};